import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { BoatGroup, HandicapSystem } from '../boatList/BoatDetails';
import { AppDispatch } from '../../app/store';
import { useDispatch } from 'react-redux';
import { updateGroup } from '../boatList/boatListSlice';
import { analyticsService } from '../../services/AnalyticsService';


export interface GroupDetailsEditProps {
  show: boolean,
  handleClose: () => void,
  group: BoatGroup
}

export function GroupDetailsEdit(props: GroupDetailsEditProps) {
  const dispatch: AppDispatch = useDispatch();

  const [groupDetails, setGroupDetails] = React.useState<BoatGroup>(props.group);

  function handleClose() {
    console.log(`GroupDetailsEdit.handleClose ${props.group.id}`);
    props.handleClose();
    // TODO should this reset state?
  }

  function handleSave() {
    console.log(`GroupDetailsEdit.handleSave ${props.group.id}`);

    // Track handicap system selection if it changed
    if (groupDetails.handicapSystem !== props.group.handicapSystem) {
      analyticsService.logEvent('handicap_system_selection', {
        previous_system: props.group.handicapSystem,
        selected_system: groupDetails.handicapSystem,
        boat_count_affected: groupDetails.boatDetails?.length || 0,
        selection_method: 'group_edit_modal',
        group_id: props.group.id,
      });
    }

    // Track group update
    analyticsService.logEvent('boat_management', {
      action_type: 'group_updated',
      group_id: props.group.id,
      feature_name: 'group_details_edit',
      has_name_change: groupDetails.name !== props.group.name,
      has_handicap_system_change: groupDetails.handicapSystem !== props.group.handicapSystem,
    });

    dispatch(updateGroup(groupDetails));
    props.handleClose();
    // TODO should this reset state?
  }

  function handleInputChange(event: React.ChangeEvent<HTMLInputElement>) {
    console.log('GroupDetailsEdit.handleInputChange', event);
    const name = event.target.name;
    const value = event.target.value;
    console.log(`GroupDetailsEdit.handleInputChange name:${name} value:${value}`);
    setGroupDetails((values) => ({ ...values, [name]: value }));
  }
  function handleSelectChange(event: React.ChangeEvent<HTMLSelectElement>) {
    console.log('GroupDetailsEdit.handleSelectChange', event);
    const name = event.target.name;
    const value = event.target.value;
    console.log(`GroupDetailsEdit.handleSelectChange name:${name} value:${value}`);

    // Track handicap system selection in real-time
    if (name === 'handicapSystem' && value !== groupDetails.handicapSystem) {
      analyticsService.logEvent('handicap_system_selection', {
        previous_system: groupDetails.handicapSystem,
        selected_system: value,
        boat_count_affected: groupDetails.boatDetails?.length || 0,
        selection_method: 'dropdown',
        group_id: props.group.id,
      });
    }

    setGroupDetails((values) => ({ ...values, [name]: value }));
  }

  return <Modal show={props.show} onHide={handleClose}>
    <Modal.Header closeButton>
      <Modal.Title>Edit Group Details</Modal.Title>
    </Modal.Header>

    <Modal.Body>
      <Form>
        <Form.Group className="mb-3" controlId="id">
          <Form.Label>Id</Form.Label>
          <Form.Control readOnly disabled type="text" name="id" value={groupDetails.id} onChange={handleInputChange} />
        </Form.Group>
        <Form.Group className="mb-3" controlId="name">
          <Form.Label>Name </Form.Label>
          <Form.Control type="text" name="name" value={groupDetails.name} onChange={handleInputChange} />
        </Form.Group>
        <Form.Group className="mb-3" controlId="handicap">
          <Form.Label>Handicap System </Form.Label>
          <Form.Select name="handicapSystem" value={groupDetails.handicapSystem} onChange={handleSelectChange}>
            {Object.keys(HandicapSystem).map((handicapSystem) =>
              <option key={handicapSystem} value={handicapSystem}>{handicapSystem}</option>,
            )}
          </Form.Select>
        </Form.Group>
      </Form>
    </Modal.Body>

    <Modal.Footer>
      <Button variant="secondary" onClick={handleClose}>Close</Button>
      <Button variant="primary" onClick={handleSave}>Save changes</Button>
    </Modal.Footer>
  </Modal>;
}
